import React from 'react';
import './project statistics.css'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import { setUser } from '../../redux/actions/AuthActions'
import moment from 'moment'
import { Spin, DatePicker, TreeSelect } from 'antd';
import 'moment/locale/ar';
import { withRouter, Redirect } from 'react-router-dom'
import StatisticCard from '../../component/statisticCard/statisticCard';
const { TreeNode } = TreeSelect;


class ProjectStatistics extends React.Component {

  state = {
    count: [],
    loading: false,
    startDate: null,
    endDate: null,
    projects: [],
    project: null
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
      moment.locale('ar');
    } else {
      allStrings.setLanguage('en')
      moment.locale('en');
    }
  }

  componentDidMount() {
    this.getProjects()
  }

  onStartDateChange = (date) => {
    this.setState({
      startDate: date ? date.locale("en").format("YYYY-MM-DD") : null
    }, () => {
      this.fetchAllData();
    });
  }

  onEndDateChange = (date) => {
    this.setState({
      endDate: date ? date.locale("en").format("YYYY-MM-DD") : null
    }, () => {
      this.fetchAllData();
    });
  }

  fetchAllData = () => {
    this.getProjectStatistics(this.state.project);
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data, project: response.data.data[0].id })
        this.fetchAllData();
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getProjectStatistics = (project) => {
    const { startDate, endDate } = this.state;
    axios.get(`${BASE_END_POINT}projects/${project}/ownerProjectReport/get`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
      params: { startDate, endDate, project }
    })
      .then(response => {
        this.setState({ count: response.data, loading: false })
      })
      .catch(error => {
        console.log("ALL count ERROR", error.response)
      })
  }
  render() {
    if (!this.props.currentUser.user.type === "ADMIN") return <Redirect to='/Home' />

    const { loading } = this.state;


    return (
      <div className="statistics">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            <MDBRow>
              <div style={{
                textAlign: this.props.isRTL ? 'right' : 'left',
                flexDirection: this.props.isRTL ? 'row' : 'row-reverse',
                display: this.props.isRTL ? '' : 'flex',
                width: this.props.isRTL ? '100%' : '', padding: '5px 20px 25px'
              }}>
                <span style={{
                  display: 'inline-block',
                  color: '#43425D',
                  fontSize: '22px'
                }}>{allStrings.onThisMonth}</span>
                <span style={{
                  fontWeight: 'bold', fontSize: '22px', display: 'inline-block',
                  color: '#43425D', margin: '6px', lineHeight: this.props.isRTL ? 'auto' : '15px'
                }}>|</span>
                <span style={{
                  fontWeight: 'bold', fontSize: '22px', display: 'inline-block',
                  color: '#43425D'
                }}>{allStrings.statistic}</span>
              </div>

            </MDBRow>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol md="4" sm="4">
                <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{this.props.isRTL ? "من تاريخ" : "From Date"}</label>
                <DatePicker
                  onChange={this.onStartDateChange}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  placeholder={this.props.isRTL ? 'من تاريخ' : 'Start Date'}
                />
              </MDBCol>
              <MDBCol md="4" sm="4">
                <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{this.props.isRTL ? "إلى تاريخ" : "To Date"}</label>
                <DatePicker
                  onChange={this.onEndDateChange}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  placeholder={this.props.isRTL ? 'إلى تاريخ' : 'End Date'}
                />
              </MDBCol>
              <MDBCol md="4" sm="4">
                <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                <TreeSelect virtual={false}
                  showSearch={true}
                  style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                  treeCheckable={false}
                  value={this.state.project}
                  treeNodeFilterProp="title"
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder={allStrings.project}
                  onChange={(value) => {
                    console.log(value)
                    this.setState({ project: value });
                    this.getProjectStatistics(value);
                  }}
                >
                  {this.state.projects.map(val => (
                    <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                  ))}
                </TreeSelect>
              </MDBCol>
            </MDBRow>
            <br></br>
            <br></br>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <StatisticCard
                name={allStrings.lastUpdated}
                value={moment(this.state.count.lastUpdated).format("dddd D MMMM YYYY hh:mm A")}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.contactCount}
                value={this.state.count.contactCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.visitingsCount}
                value={this.state.count.visitingsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.totalViews}
                value={this.state.count.totalViews}
                isRTL={this.props.isRTL}
                loading={loading}
              />

              <StatisticCard
                name={allStrings.bookedCount}
                value={this.state.count.bookedCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.soldCount}
                value={this.state.count.soldCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.deliveredCount}
                value={this.state.count.deliveredCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.completedCount}
                value={this.state.count.completedCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />

              <StatisticCard
                name={allStrings.bookedAmount}
                value={this.state.count.bookedAmount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.soldAmount}
                value={this.state.count.soldAmount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.deliveredAmount}
                value={this.state.count.deliveredAmount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.completedAmount}
                value={this.state.count.completedAmount}
                isRTL={this.props.isRTL}
                loading={loading}
              />

              <StatisticCard
                name={allStrings.completedDeals}
                value={this.state.count.completedDeals}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.unCompletedDeals}
                value={this.state.count.unCompletedDeals}
                isRTL={this.props.isRTL}
                loading={loading}
              />
            </MDBRow>
          </MDBContainer>
        </Spin>
      </div>
    )
  }
}
const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})
const mapDispatchToProps = {
  setUser,
  ChangeLanguage
}
export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(ProjectStatistics)
);